import { useFormConnect } from '../../../../hooks/useFormConnect';
import { CheckBox } from '../../Inputs/Checkbox/Checkbox';

export const Checkbox = ({ name, label = '' }) => {
  const props = useFormConnect(name);
  return <CheckBox label={label} {...props} />;
};
